import { DEFAULT_LOCALE, type SupportedLocale } from "./config";

export interface ConsentTranslationRow {
    consent_name?: string | null;
    summary_text?: string | null;
    attestation_text?: string | null;
    document_url?: string | null;
}

export interface LocalizableConsent {
    consent_name?: string | null;
    summary_text?: string | null;
    attestation_text?: string | null;
    document_url?: string | null;
}

/** Overlay locale-specific consent copy onto canonical English fields. */
export function applyConsentTranslations<T extends LocalizableConsent>(
    consent: T,
    locale: SupportedLocale,
    translation: ConsentTranslationRow | null | undefined
): T {
    if (locale === DEFAULT_LOCALE || !translation) {
        return consent;
    }

    return {
        ...consent,
        ...(translation.consent_name != null ? { consent_name: translation.consent_name } : {}),
        ...(translation.summary_text != null ? { summary_text: translation.summary_text } : {}),
        ...(translation.attestation_text != null ? { attestation_text: translation.attestation_text } : {}),
        ...(translation.document_url != null ? { document_url: translation.document_url } : {}),
    };
}
